import axios from 'axios'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

import BottomDrawer from '@/components/bottomDrawer'
import { STRINGS } from '@/constants/faq'

interface FAQList {
  id: number
  question: string
  answer: string
}

const Faq: React.FC = () => {
  const { query, push } = useRouter()
  // const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [faqList, setFaqList] = useState<FAQList[]>([])
  const [loading, setLoading] = useState(true)
  // const { name, number } = query

  useEffect(() => {
    const fetchFaqs = async () => {
      const baseUrl = process.env.NEXT_PUBLIC_CMS_BASE_URL
      try {
        const response = await axios.get(
          `${baseUrl}/api/faqs?filters[primary_slug][$eq]=input&filters[secondary_slug][$eq]=variable-pay&populate=deep`,
          {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${process.env.NEXT_PUBLIC_CMS_TOKEN}`,
            },
          }
        )
        if (
          response &&
          response.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length > 0
        ) {
          setFaqList(response.data.data[0].attributes.list.list)
        } else {
          push('/404')
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        push('/404')
      }
      setLoading(false)
    }

    fetchFaqs()
  }, [push])

  return (
    <div className="flex flex-col justify-center ml-10 mr-6 my-8">
      {loading && <div>...Loading</div>}
      <p className="font-sans text-3xl font-black text-center text-gray-900">
        {STRINGS.FAQ}
      </p>
      <ul className="list-disc space-y-3 mt-2 mb-9">
        {faqList &&
          faqList.map((item) => {
            return (
              <li key={item.id}>
                <p className="font-sans text-base font-bold text-gray-900">
                  {item.question}
                </p>
                <p className="font-sans text-sm font-light text-gray-900 mt-1">
                  {item.answer}
                </p>
              </li>
            )
          })}
      </ul>
      {/* <button
        onClick={() => setIsDrawerOpen(true)}
        className="bg-green-700 text-white text-bold px-4 py-2 rounded-lg"
      >
        {STRINGS.ADD_A_QUERY}
      </button>
      <BottomDrawer
        title={STRINGS.ADD_A_QUERY}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      >
        <div className="flex flex-1 flex-col w-full">
          {!name ? (
            <div className="border mt-2 mb-2 mx-4 px-4 py-2 border-[#E6EBF0] rounded-md">
              <p className="text-xs font-normal text-dehaat-green">
                {STRINGS.NAME}
              </p>
              <input
                type="text"
                className="w-full p-1 font-normal text-base"
                placeholder="Enter name"
              />
            </div>
          ) : null}
          {!number ? (
            <div className="border mt-2 mb-2 mx-4 px-4 py-2 border-[#E6EBF0] rounded-md">
              <p className="text-xs font-normal text-dehaat-green">
                {STRINGS.PHONE_NUMBER}
              </p>
              <input
                type="text"
                className="w-full p-1 font-normal text-base"
                placeholder="Enter phone number "
              />
            </div>
          ) : null}
          <div className="border mt-2 mb-2 mx-4 px-4 py-2 border-[#E6EBF0] rounded-md">
            <p className="text-xs font-normal text-dehaat-green">
              {STRINGS.OUERY}
            </p>
            <input
              type="text"
              className="w-full p-1 font-normal text-base"
              placeholder="I need help with..."
            />
          </div>
          <button className="bg-green-700 my-2 mx-4 text-white text-bold px-4 py-3 rounded-lg">
            {STRINGS.SUBMIT}
          </button>
        </div>
      </BottomDrawer> */}
    </div>
  )
}

export default Faq

//release 2.0
